import { useEffect, useState } from 'react';
import { PosSpinner } from 'src/core/POS/PosSpinner';

import { ChartHeaderInput } from '../ChartHeader';
import * as styles from '../DataInsightsChart.css';
import { SaleChartData, useDataInsights } from '../DataInsightsContext';
import { DataLineChart } from '../LineChart/DataLineChart';
import { TargetInput } from '../TargetInput';
import { TimePeriodSelector } from '../TimePeriodSelector';

type PnLChartData = Pick<SaleChartData, 'dateTime' | 'totalPnl'>;

export const PnlChart = ({
  data,
  renderHeader,
}: {
  data: SaleChartData[] | null;
  renderHeader: (input: ChartHeaderInput) => JSX.Element;
}) => {
  const {
    uiCurrency,
    targetValue,
    setTargetValue,
    isLoading,
    paddedChartData,
    isScrolling,
  } = useDataInsights();

  const [pnlValue, setPnlValue] = useState<number | null>(
    data && data.length > 0 ? data[data.length - 1].totalPnl : null
  );

  useEffect(() => {
    if (data && data.length > 0) {
      setPnlValue(data[data.length - 1].totalPnl);
    }
  }, [data]);

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: uiCurrency.code,
  });
  const prefix = ((pnlValue || 0) > 0 ? '+' : '-') + uiCurrency.sym;

  return (
    <>
      {renderHeader({
        value: Math.abs(pnlValue || 0),
        prefix: prefix,
        isScrolling,
        subtitle: targetValue
          ? `${(pnlValue || 0) > targetValue ? '+' : '-'} ${currencyFormatter.format(
              Math.abs((pnlValue || 0) - targetValue)
            )} vs Target`
          : '',
      })}

      <DataLineChart
        data={data}
        paddedData={paddedChartData}
        setValue={setPnlValue}
        valueKey="totalPnl"
      />
      <TimePeriodSelector />
      <TargetInput targetValue={targetValue} setTargetValue={setTargetValue} />
    </>
  );
};
